import { BaseService } from "@/script/core/service/BaseService";
import { Failure, Success } from "@/script/core/service/DataService";
import { Content } from "../entity/CmsEntity";

export class ContentService extends BaseService {
  public staticize(id: number, success?: Success, failure?: Failure) {
    super.get("/api/staticize/content", { id }).then(
      function (result) {
        if (success) {
          success(result.data);
        }
      },
      function (error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }

  public pinyin(name: string): Promise<any> {
    return super.get("/api/cms/content/pinyin/simple", { name });
  }

  public generateCode(pre: string): Promise<any> {
    return super.get("/api/cms/content/code/generate", { pre });
  }

  public loadChildContents(id: number): Promise<any> {
    return super.get("/api/cms/content/list/query/child", { id });
  }

  public setTop(content: Content): Promise<any> {
    return super.post("/api/cms/content/top", content);
  }

  public release(content: Content): Promise<any> {
    return super.post("/api/cms/content/release", content);
  }
}
